gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  const header = document.querySelector(".main-header");
  const mobileheader = document.querySelector(".mobile-header");
  const logoFloat = document.querySelector(".logo-float-wrap");
  const banner = document.querySelector(".banner");
  const nav = document.querySelector(".main-nav");
  const hamburger = document.querySelector(".hamburger");
  const consent = document.querySelector(".consent");
  const closeConsent = document.querySelector(".closeConsent");

  const openPol = [...document.querySelectorAll(".openModal")];
  const closePol = [...document.querySelectorAll(".closeBtn")];
  const pol = document.querySelector(".modal");

  const navLinks = [...document.querySelectorAll(".navLink")];

  var phone_inputs = document.querySelectorAll('input[type="tel"]');
  var phoneMaskOptions = {
    mask: "(00) [0]0000-0000",
  };
  phone_inputs.forEach(function (field) {
    var mask = IMask(field, phoneMaskOptions);
  });

  navLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const link = e.target.dataset.link;
      hamburger.classList.remove("is-active");
      nav.classList.remove("is-active");
      mobileheader.classList.remove("open");

      gsap.to(window, { duration: 1, scrollTo: `#${link}` });
    });
  });

  openPol.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      pol.classList.add("open");
      body.classList.add("hasmodal");
    });
  });

  closePol.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      pol.classList.remove("open");
      body.classList.remove("hasmodal");
    });
  });

  if (sessionStorage.getItem("consent") === null) {
    consent.classList.add("show");
  }

  closeConsent.addEventListener("click", (e) => {
    e.preventDefault();
    consent.classList.remove("show");
    sessionStorage.setItem("consent", "true");
  });

  hamburger.addEventListener("click", (e) => {
    e.preventDefault();
    hamburger.classList.toggle("is-active");
    nav.classList.toggle("is-active");
    mobileheader.classList.toggle("open");
  });

  const sectionOneOptions = {
    // rootMargin: "-95% 0% 0% 0%"
  };
  const sectionOneObserver = new IntersectionObserver(function (
    entries,
    sectionOneObserver
  ) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        header.classList.add("scrolled");
        logoFloat.classList.add("open");
      } else {
        header.classList.remove("scrolled");
        logoFloat.classList.remove("open");
      }
    });
  },
  sectionOneOptions);

  sectionOneObserver.observe(banner);

  function counter(id, start, end, duration) {
    let obj = document.getElementById(id),
      current = start,
      range = end - start,
      increment = end > start ? 1 : -1,
      step = Math.abs(Math.floor(duration / range)),
      timer = setInterval(() => {
        current += increment;
        obj.textContent = current;
        if (current == end) {
          clearInterval(timer);
        }
      }, step);
  }

  const counterObserver = new IntersectionObserver(function (
    entries,
    sectionOneObserver
  ) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        counter("count1", 0, 155, 1000);
        counter("count2", 0, 90, 1300);
        counter("count3", 0, 120, 1600);
        counter("count4", 0, 21, 1900);
        counter("count5", 0, 100, 2100);
      }
    });
  },
  sectionOneOptions);

  const dados = document.querySelector(".cards");
  counterObserver.observe(dados);

  gsap.from(".ani-right", {
    scrollTrigger: ".ani-right",
    x: 100,
    opacity: 0,
    duration: 1,
    stagger: 0.2,
    ease: "power4",
  });
  gsap.from(".banner__logo", {
    scrollTrigger: ".banner__logo",
    y: -100,
    opacity: 0,
    duration: 1,
    stagger: 0.2,
    ease: "power4",
  });
  gsap.from(".ani-bottom", {
    scrollTrigger: {
      trigger: ".ani-bottom",
      toggleActions: "play reset play reset",
    },
    y: 100,
    opacity: 0,
    duration: 1,
    stagger: 0.2,
    ease: "power4",
  });
  gsap.from(".conheca .lines", {
    scrollTrigger: {
      trigger: ".conheca .lines",
      toggleActions: "play reset play reset",
    },
    x: -100,
    opacity: 0,
    duration: 2,
    stagger: 0.2,
    ease: "power4",
  });
  gsap.from(".ani-left", {
    scrollTrigger: ".ani-left",
    x: -100,
    opacity: 0,
    duration: 1,
    stagger: 0.2,
    ease: "powe4",
  });
  gsap.from(".linhablue1", {
    scrollTrigger: {
      trigger: ".linhablue1",
      toggleActions: "play reset play reset",
    },
    y: 100,
    opacity: 0,
    duration: 2,
    stagger: 0.2,
    ease: "power4",
  });
  gsap.from(".linhablue2", {
    scrollTrigger: {
      trigger: ".linhablue2",
      toggleActions: "play reset play reset",
    },
    y: -100,
    opacity: 0,
    duration: 2,
    stagger: 0.2,
    ease: "power4",
  });
  gsap.from(".linhasgreen2", {
    scrollTrigger: {
      trigger: ".linhasgreen2",
      toggleActions: "play reset play reset",
    },
    y: 100,
    opacity: 0,
    duration: 2,
    stagger: 0.2,
    ease: "power4",
  });
});
